import { render, staticRenderFns } from "./MultiPaneLayout.vue?vue&type=template&id=6f358b0b&scoped=true&"
import script from "./MultiPaneLayout.vue?vue&type=script&lang=js&"
export * from "./MultiPaneLayout.vue?vue&type=script&lang=js&"
import style0 from "./MultiPaneLayout.vue?vue&type=style&index=0&id=6f358b0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f358b0b",
  null
  
)

export default component.exports